import {browserHistory} from 'react-router';

export default browserHistory;


// WEBPACK FOOTER //
// ./src/components/history.js